<template>
<transition name="time-fix-fade">
<div class="time-fix" :style="{backgroundColor:ads.background_color || primaryColor,backgroundImage:'url(' + ads.background_picture || '' +')'}" v-show="show">
  <div class="timefix-container">
    <img :src="ads.picture" class="time-fix-logo">
    <!-- <img v-else src="./assets/logo-aicon-w.svg" class="time-fix-logo"> -->
    <p v-html="ads.content" class="time-fix-intro"></p>
    <a class="time-fix-close hairline" @click="close"></a>
  </div>
</div>
</transition>
</template>

<script>
// import moment from 'moment'

export default {
  data () {
    // let intro, type
    // type = 'hidden'
    // if (moment().isAfter('2018-01-12T20:00:00.00+08:00')) {
    //   type = 'ppt'
    //   intro = `<a href='https://time.geekbang.org/?utm_source=website&utm_medium=aicon&utm_campaign=tiaofu&utm_content=geeklive' target='_blank'>下载极客时间</a> ，AICon 大会直播免费看。`
    // }
    // if (moment().isAfter('2018-01-13T18:00:00.00+08:00')) {
    //   type = 'ppt'
    //   intro = `数据科学家洪亮劼答“人工智能20问”，<a href='https://time.geekbang.org/?utm_source=web&utm_medium=aicon&utm_campaign=promotion&utm_content=hongliangjiezhibo' target='_blank'>下载极客时间App观看！</a> `
    // }
    // if (moment().isAfter('2018-01-13T22:00:00.00+08:00')) {
    //   type = 'aicon'
    //   intro = `<a href='https://ppt.geekbang.org/aicon2017?utm_source=aicon2017' target='_blank'>AICon 大会全部 PPT 下载戳这里>>></a>`
    // }

    return {
      // intro,
      show: false
      // type // 'ppt', 'aicon', 'hidden'
    }
  },
  props: {
    ads: {
      type: Object,
      default: function () { return {} }
    },
    primaryColor: {
      type: String,
      default: function () { return '' }
    }
  },
  computed: {
  },
  mounted () {
    setTimeout(() => {
      if (this.type !== 'hidden') this.show = true
    }, 1000)
  },
  beforeDestroy () {
  },
  methods: {
    close () {
      this.show = false
    }
  }
}
</script>

<style lang="sass">
.time-fix
  position: fixed
  bottom: 0
  left: 0
  right: 0
  height: 60px
  color: #fff
  font-size: 18px
  z-index: 1000
  +mobile
    height: 50px
.timefix-container
  margin: 0 auto
  width: 1150px
  height: 100%
  display: flex
  align-items: center
  justify-content: space-between
  +mobile
    width: 96vw
.time-fix-logo
  height: 60%
  margin-right: 40px
  flex-shrink: 0
  +mobile
    height: 50%
    margin-right: 10px
.time-fix-intro
  flex-grow: 1
  font-size: 16px
  a
    color: rgb(239,219,2)
    text-decoration: underline
  +mobile
    font-size: 12px
.time-fix-close
  flex-shrink: 0
  position: relative
  display: inline-block
  width: 25px
  height: 25px
  overflow: hidden
  cursor: pointer
  +mobile
    height: 15px
    width: 15px
  &::before, &::after
    content: ''
    position: absolute
    height: 2px
    width: 100%
    top: 50%
    left: 0
    margin-top: -1px
    background: #fff
  &::before
    transform: rotate(45deg)
  &::after
    transform: rotate(-45deg)
  &.hairline
    &::before, &::after
      height: 1px
.time-fix-fade-enter-active, .time-fix-fade-leave-active
  transition: opacity 0.4s
.time-fix-fade-enter, .time-fix-fade-leave-to
  opacity: 0
.time-fix-fade-enter-to, .time-fix-fade-leave
  opacity: 1
</style>
